import { render, staticRenderFns } from "./type-input.vue?vue&type=template&id=560535bf&scoped=true&"
import script from "./type-input.vue?vue&type=script&lang=js&"
export * from "./type-input.vue?vue&type=script&lang=js&"
import style0 from "./type-input.vue?vue&type=style&index=0&id=560535bf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560535bf",
  null
  
)

export default component.exports